/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var NaturalDelay = new Class({
    minNaturalDelay: 500,
    maxNaturalDelay: 1500,
    getNaturalDelayConfig:function(){
        return {
            min: this.minNaturalDelay,
            max: this.maxNaturalDelay
        }
    },
    setNaturalDelayConfig:function(config){
        this.minNaturalDelay = config.min;
        this.maxNaturalDelay = config.max;
    },
    getShortDelay: function(minDelay) {
        return Math.floor(minDelay + Math.random() * (this.maxNaturalDelay - minDelay) / 2);
    },
    getNaturalDelay: function(type){
        var minProgressDelay = this.minNaturalDelay > 2000 ? 2000 : this.minNaturalDelay;
        switch(type){
            case 'direct':
                return 0;
            case 'short':
                return this.getShortDelay(this.minNaturalDelay);
            case 'progress':
                return this.getShortDelay(minProgressDelay);
            default:
                return Math.floor(this.minNaturalDelay + Math.random() * (this.maxNaturalDelay - this.minNaturalDelay));
        }
    }
});
